import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import withProps from 'recompose/withProps';
import DownloadScheduleHistoryButton from '../components/DownloadScheduleHistoryButton';
import { downloadScheduleHistory } from '../actions';
import { getById } from '../selector';
import { canUserModifyBarbers } from '../../../common/helpers/users';

const mapStateToProps = (state, ownProps) => ({
  canModifyProducts: canUserModifyBarbers(state.auth.permissions),
  barber: getById(state, ownProps.barberId),
});

export default compose(
  connect(mapStateToProps),
  withState('downloading', 'setDownloading', false),
  withHandlers({
    downloadHistory: ({ barber, setDownloading }) => () => {
      setDownloading(true);
      downloadScheduleHistory(barber).finally(() => setDownloading(false));
    },
  }),
  withProps(props => ({
    disabled: !props.canModifyProducts || props.downloading,
  })),
)(DownloadScheduleHistoryButton);
